<div class="page-container">
  <div class="banner-section" [ngStyle]="{ 'background-image': 'url(' + bannerImageUrl + ')' }">
  
    <div class="banner-text">
      <h1>{{homepage.title}}</h1>
      <p>{{homepage.description}}</p>
      <button class="button bannerBtn" (click)="buttonAction()"
       appTrackClick 
        [buttonProps]="{
          title: 'home_loggedout_top_join_free_button',
          feature_context: 'HOME'
        }"
      >{{bannerButton}}</button>
    </div>
  </div>

  <div class="cardSection">
      <div class="cards-container">
          <div class="card-wrapper" *ngFor="let card of cards">
            <h3 class="card-heading" (click)="redirect(card?.url)"
             appTrackClick 
              [buttonProps]="{
                title: 'home_loggedout_'+card?.title+'_card_clicked',
                feature_context: 'HOME'
              }"
            >{{ card?.title }}</h3>
            <div class="card" (click)="redirect(card.url)"
              appTrackClick 
              [buttonProps]="{
                title: 'home_loggedout_'+card?.title+'_card_clicked',
                feature_context: 'HOME'
              }"
            >
              <img src="{{card?.image}}" alt="Image" />
              <div class="card-description">
                <p>{{ card?.description }}</p>
              </div>
            </div>
          </div>
        </div>
      <button class="button bannerBtn color" (click)="buttonAction()"
        appTrackClick 
        [buttonProps]="{
          title: 'home_loggedout_bottom_join_free_button',
          feature_context: 'HOME'
        }"
      >{{bannerButton}}</button>
  </div>
</div>